import React, { useEffect } from 'react';
import { Form, Select } from 'antd';

type Props = {
  renderInfo: Array<string>;
  style: Object;
  enums: any;
  // Form.Item包裹后，会自动传的props
  id: any,
  value: Array<string>;
  onChange: Function;
};

export const SPMileLimitSelect: React.FC<Props> = (props) => {
  const { id, value, onChange, style, enums } = props
  const form = Form.useFormInstance()
  const selectName1 = `${id}_select1`
  const selectName2 = `${id}_select2`

  const handleFirstSelectChange = (currSelectVal: string) => {
    if (value[1] && value[1] !== '不限制') {
      onChange([value[0], currSelectVal, value[2], value[3], value[4]])
      return
    }
    onChange([value[0], currSelectVal, value[2], '', value[4]])
  }
  
  const handleSecondSelectChange = (currSelectVal: string) => {
    onChange([value[0], value[1], value[2], currSelectVal, value[4]])
  }

  // 注意：组件内包了一层From.Item后(为了使用rules)，组件内不setFieldsValue，可以回显，但会触发非空校验
  useEffect(() => {
    form.setFieldsValue({
      [selectName1]: value[1],
      [selectName2]: value[3],
    })
}, []);

  return (<>
    <span>{value[0]}</span>
    <Form.Item name={selectName1} noStyle rules={[{ required: true, message: '请选择' }]}>
      <Select
        style={style}
        onChange={handleFirstSelectChange}
        defaultValue={value[1]}
        options={enums?.f_mile_limit}
      />
    </Form.Item>
    {value[1] && value[1] !== '不限制' && <>
      <span>{value[2]}</span>
      <Form.Item name={selectName2} noStyle rules={[{ required: true, message: '请选择' }]}>
        <Select
          style={style}
          onChange={handleSecondSelectChange}
          defaultValue={value[3]}
          options={enums?.f_over_mile_limit_charge}
        />
      </Form.Item>
      <span>{value[4]}</span>
    </>}
  </>);
};